import {
  ADD_SYSTEM_USER_REQUEST,
  ADD_SYSTEM_USER_SUCCESS,
  ADD_SYSTEM_USER_FAILURE,
  ADD_SYSTEM_USER_RESET,
} from '../../../redux/types/user';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: '',
};

const addSystemUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SYSTEM_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: '',
      };

    case ADD_SYSTEM_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || 'User added successfully',
      };

    case ADD_SYSTEM_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || 'Something went wrong',
        success: false,
        message: '',
      };

    case ADD_SYSTEM_USER_RESET:
      return { ...initialState };

    default:
      return state;
  }
};

export default addSystemUserReducer;
